import React from 'react';
import { motion } from 'framer-motion';
import './PuzzleReveal.css';

/**
 * Puzzle-piece entrance: each child animates in from a different direction
 * and scale so the page feels like pieces fitting together.
 */
const PIECE_ORIGINS = [
  { x: '0%', y: '-25%', scale: 0.92, rotate: -1 },
  { x: '15%', y: '-15%', scale: 0.9, rotate: 1 },
  { x: '-28%', y: '0%', scale: 0.92, rotate: 2 },
  { x: '28%', y: '0%', scale: 0.92, rotate: -2 },
  { x: '-22%', y: '0%', scale: 0.9, rotate: 1 },
  { x: '0%', y: '22%', scale: 0.92, rotate: -1 },
  { x: '22%', y: '0%', scale: 0.9, rotate: 2 },
  { x: '0%', y: '18%', scale: 0.9, rotate: -1 }
];

const PuzzleReveal = ({ show, children }) => {
  const childArray = React.Children.toArray(children);

  return (
    <motion.div
      className="puzzle-reveal"
      initial={false}
      animate={{
        opacity: show ? 1 : 0,
        pointerEvents: show ? 'auto' : 'none'
      }}
      transition={{ duration: 0.2 }}
    >
      {childArray.map((child, i) => {
        const origin = PIECE_ORIGINS[i % PIECE_ORIGINS.length] ?? PIECE_ORIGINS[0];
        return (
          <motion.div
            key={i}
            className="puzzle-piece"
            initial={{
              x: origin.x,
              y: origin.y,
              scale: origin.scale,
              rotate: origin.rotate,
              opacity: 0
            }}
            animate={
              show
                ? {
                    x: 0,
                    y: 0,
                    scale: 1,
                    rotate: 0,
                    opacity: 1
                  }
                : {
                    x: origin.x,
                    y: origin.y,
                    scale: origin.scale,
                    rotate: origin.rotate,
                    opacity: 0
                  }
            }
            transition={{
              type: 'spring',
              damping: 24,
              stiffness: 140,
              delay: show ? i * 0.08 : 0,
              opacity: { duration: 0.35, delay: show ? i * 0.06 : 0 }
            }}
          >
            {child}
          </motion.div>
        );
      })}
    </motion.div>
  );
};

export default PuzzleReveal;
